type ImageLoadStatus = 'pending' | 'loaded' | 'error'

interface PreloadImage {
  src: string
  status: ImageLoadStatus
}

class ImagePreloader {
  private images: PreloadImage[] = []

  constructor(imageUrls?: string[]) {}

  start(data: string[]): Promise<void[]> {
    const promises = data.map((image) =>
      this.loadImage({ src: image, status: 'pending' })
    )
    return Promise.all(promises)
  }

  private loadImage(image: PreloadImage): Promise<void> {
    return new Promise((resolve, reject) => {
      const img = new Image()
      img.src = image.src

      this.images.push(image)

      img.onload = () => {
        image.status = 'loaded'
        this.testImage(image.src)
        resolve()
      }

      img.onerror = () => {
        image.status = 'error'
        reject(new Error(`Failed to load image: ${image.src}`))
      }
    })
  }

  testImage(url: string) {
    const hiddenDiv = document.createElement('div')
    hiddenDiv.style.backgroundImage = `url(${url})`
    hiddenDiv.style.width = '0'
    hiddenDiv.style.height = '0'
    hiddenDiv.style.overflow = 'hidden'
    hiddenDiv.style.position = 'absolute'
    hiddenDiv.style.visibility = 'hidden'
    hiddenDiv.id = `preloaded-image-${Date.now()}`
    document.body.appendChild(hiddenDiv)
  }

  getStatus(): PreloadImage[] {
    return this.images
  }
}

export const PreloadImg = new ImagePreloader()

/** 预加载资源文件 */
export function preloadAssets({ images } = {} as { images?: string[] }) {
  // 预加载图片
  if (images?.length) {
    PreloadImg.start(images)
  }
}
